function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2UserLoanPlan(user_id, loan_plan_id) {
  return `${apiBaseUrl()}/api/v2/users/${user_id}/loan_plans/${loan_plan_id}`;
}

export function apiV2UserLoanPlans(user_id) {
  return `${apiBaseUrl()}/api/v2/users/${user_id}/loan_plans`;
}

export function apiV2UserLoanPlanRepayments(user_id, loan_plan_id) {
  return `${apiBaseUrl()}/api/v2/users/${user_id}/loan_plans/${loan_plan_id}/repayments`;
}


// WEBPACK FOOTER //
// ./src/features/loans/loanPlanApiUrls.js